<template>
        <div class="digital-classrooms-event" :class="getClassByState">
            <div class="digital-classrooms-event__table-row">
                <div class="digital-classrooms-event__table-cell digital-classrooms-event__name" v-if="showEventName">
                    <router-link :to="getRouteToCourse(event.course)">{{ event.title }}</router-link>
                </div>

                <div class="digital-classrooms-event__table-cell digital-classrooms-event__date">
                    <EventDateRangeRow
                        v-if="isEventDateRange"
                        :eventDateRange="eventDateRange"
                        :isUserSignedToEvent="isUserSignedToEvent"
                        :showDateDropDown="showDateDropDown"
                        v-on:toggleDatesDropDown="toggleDatesDropDown"
                    />
                    <div v-else>
                        <div v-for="(date, index) in getEventDates" :key="index">
                            {{ date }} <span v-if="index !== getEventDates.length - 1">&</span>
                        </div>
                    </div>
                </div>

                <div class="digital-classrooms-event__table-cell digital-classrooms-event__time">
                    <span v-if="!isEventDateRange">{{ getEventTime }}</span>
                </div>

                <div class="digital-classrooms-event__table-cell digital-classrooms-event__duration">
                    {{ isEventDateRange ? getIntervalEventsTotalDuration : getEventDuration }}
                </div>

                <IntervalSessionDetails
                    :sessions="event.sessions"
                    :showDateDropDown="showDateDropDown"
                    :showEventName="showEventName"
                    v-if="isEventDateRange && isMobileView"
                />

                <div v-if="!isPastEvent" class="digital-classrooms-event__table-cell digital-classrooms-event__seats">
                    <span v-html="$t('DigitalClassrooms.seats')" class="digital-classrooms-event__seats-label"></span>
                    {{ getEventSeats }}
                </div>
                <div v-else class="digital-classrooms-event__table-cell"></div>

                <DigitalClassRoomSignupButton
                    v-if="!isPastEvent"
                    :isPastEvent="isPastEvent"
                    :hasAccessToSignup="hasAccessToSignup"
                    :course="course"
                    :event="event"
                />
            </div>

            <IntervalSessionDetails
                :sessions="event.sessions"
                :showDateDropDown="showDateDropDown"
                v-if="isEventDateRange && isDesktopView"
            />
        </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import routeHelper from 'components/shared/mixins/routeHelper'
    import digitalClassRoomHelper from 'components/shared/mixins/digitalClassRoomHelper'
    import DigitalClassRoomSignupButton from 'components/user/signups/DigitalClassRoomSignupButton'
    import EventDateRangeRow from 'components/user/signups/EventDateRangeRow'
    import IntervalSessionDetails from 'components/user/signups/IntervalSessionDetails'

    export default {
        name: 'DigitalClassRoomEvent',
        components: {
            DigitalClassRoomSignupButton,
            EventDateRangeRow,
            IntervalSessionDetails
        },
        mixins: [ routeHelper, digitalClassRoomHelper ],
        data () {
            return {
                isProcessingCancelSignUp: false,
                showDateDropDown: false
            }
        },
        props: {
            event: Object,
            course: Object,
            isPastEvent: {
                type: Boolean,
                default: false
            },
            showEventName: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                signedUpEvents: 'Courses/getSignedUpEventsForUser'
            }),
            getClassByState () {
                if (this.isUserSignedToEvent && !this.hasEventEnded) {
                    return 'digital-classrooms-event__signed'
                }
                return ''
            },
            hasAccessToSignup () {
                return this.isLoggedIn && !this.course.demo
            },
            eventDateRange() {
                return `${this.getEventDates[0]} - ${this.getEventDates[this.getEventDates.length - 1]}`
            },
            isEventDateRange () {
                return this.getEventDates.length > 1
            },
        },
        methods: {
            toggleDatesDropDown () {
                this.showDateDropDown = !this.showDateDropDown
            }
        }
    }
</script>

<style lang="scss" scoped>
    .icon-chevron-down {
        display: inline-block;
        &.open {
            transition: transform 0.3s ease;
            transform: rotate(-180deg);
        }
        &.close {
            transform: rotate(0deg);
            transition: transform 0.3s linear;
        }
    }
    @include digital-classrooms-table;
    @include digital-classrooms-event;
</style>
